module.exports = __webpack_public_path__ + "static/img/park.24dbd34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/park.jpg
// module id = S32E
// module chunks = 0